import { css, type Theme } from "@emotion/react";
import styled from "@emotion/styled";

export const getCanvasBackgroundCss = ({ theme }: { theme: Theme }) => css`
  background-image: radial-gradient(${theme.moduleMap.backgroundSecondary} 8%, transparent 8%);
  background-color: ${theme.moduleMap.background};
  background-position: 0 0;
  background-size: 20px 20px;

  transition: background-color 300ms ease-in-out 200ms;
`;

export const CanvasElement = styled.div<{ selected?: boolean; interacting?: boolean }>`
  border: solid 1px transparent;
  border-radius: ${({ theme }) => theme.borderRadius}px;
  color: ${({ theme }) => theme.generalTextIcon};
  background-color: ${({ theme }) => theme.surface};
  user-select: none;
  box-shadow: ${({ selected, interacting, theme }) =>
    interacting ? theme.boxShadow.interacting : selected ? theme.boxShadow.selected : theme.boxShadow.normal};

  transform: ${({ interacting }) => (interacting ? "rotate3d(0, 0, 0.5, 1.5deg)" : "none")};

  transition:
    box-shadow 75ms ease-in-out,
    transform 75ms ease-in-out,
    border-color 300ms ease-in-out,
    background-color 300ms ease-in-out;

  &:hover {
    box-shadow: ${({ selected, interacting, theme }) =>
      interacting ? theme.boxShadow.interacting : selected ? theme.boxShadow.selected : theme.boxShadow.hover};
  }
  ${({ selected, theme }) =>
    selected &&
    `
      border-color: ${theme.primary};
  `}
`;
